// @ts-check

// sanitizeURL simply returns URLs if they have `http` or `https` protocols,
// otherwise it returns `about:blank`

export const protocolRegex = /^(https?:)/

export default function sanitizeUrl(url) {
	if (!url) {
		return 'about:blank'
	}

	const anchor = document.createElement('a')
	anchor.href = url

	if (protocolRegex.test(anchor.protocol)) {
		return anchor.href
	}

	return 'about:blank'
}
